import { render, staticRenderFns } from "./MetricsClient.vue?vue&type=template&id=46b7b984&scoped=true"
import script from "./MetricsClient.vue?vue&type=script&lang=js"
export * from "./MetricsClient.vue?vue&type=script&lang=js"
import style0 from "./MetricsClient.vue?vue&type=style&index=0&id=46b7b984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b7b984",
  null
  
)

export default component.exports